<template>
  <v-container fluid>
      <v-row>
        <v-col cols="12" md="4" v-for="(item, i) in integrations" :key="i">
           <v-card outlined class="fill-height d-flex flex-column">
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="mb-4">
                    <v-img 
                      contain 
                      height="40px" 
                      :src="item.image" 
                      position="left center"
                      v-if="item.image"
                    ></v-img>
                    <div v-else class="text-h5 primary--text font-weight-bold">
                       {{ item.name }}
                    </div>
                  </div>
                  <v-list-item-subtitle class="text-wrap">
                    {{ item.description }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-spacer></v-spacer>

              <v-card-actions class="d-flex flex-row-reverse pa-4 pt-0">
                <v-btn outlined color="info" class="text-capitalize" :block="isMobile" @click="item.action ? item.action() : configIntegration(item)">
                  Configurar
                </v-btn>
              </v-card-actions>
           </v-card>
        </v-col>
      </v-row>
      <CorreiosForm ref="correiosForm"></CorreiosForm>
      <IntegrationForm ref="integrationForm"></IntegrationForm>
    </v-container>

</template>

<script>
import CorreiosForm from "@/components/integrations/form/CorreiosForm";
import IntegrationForm from "@/components/integrations/form/IntegrationForm.vue";

export default {

  components: {
    CorreiosForm,
    IntegrationForm
  },

  data() {
    return {
      modal: false,
      integrations: [
        {
          name: 'Correios',
          image: require('@/assets/images/svg/correios.svg'),
          description: 'Integre sua aplicação aos Correios e otimize suas operações logísticas.',
          action: this.correiosIntegration
        },
        {
          name: 'Braip',
          image: require('@/assets/images/svg/braip.svg'),
          description: 'Integre sua aplicação à Braip para gerenciar suas vendas e afiliados.',
        },
        {
          name: 'Hotmart',
          image: require('@/assets/images/svg/hotmart.svg'),
          description: 'Conecte-se à Hotmart e automatize a gestão de seus produtos digitais.',
        },
        {
          name: 'Monetizze',
          image: require('@/assets/images/svg/monetizze.svg'),
          description: 'Sincronize suas vendas da Monetizze diretamente com nossa plataforma.',
        },
        {
          name: 'Eduzz',
          image: require('@/assets/images/svg/eduzz.svg'),
          description: 'Gerencie suas transações da Eduzz de forma simples e eficiente.',
        },
        {
          name: 'Payt',
          description: 'Integre com a Payt para processar pagamentos com segurança e agilidade.',
        },
        {
          name: 'AppMaxx',
          description: 'Conecte sua loja AppMaxx e centralize sua gestão de pedidos.',
        },
        {
          name: 'Yampi',
          description: 'Integre sua loja Yampi para sincronizar vendas e produtos.',
        },
        {
          name: 'Shopify',
          description: 'Conecte sua loja Shopify e centralize a gestão do seu e-commerce.',
        },
        {
          name: 'API',
          description: 'Utilize nossa API para criar integrações customizadas com seu sistema.',
        },
      ]
    }
  },

  methods: {
    correiosIntegration() {
      this.$refs.correiosForm.open();
    },
    configIntegration(item) {
      this.$refs.integrationForm.open(null, item.name);
    }
  },
}
</script>

<style></style>
